// src/modules/demo/hooks/useDemoAnalytics.ts

import { useCallback } from 'react';
import { track } from '@vercel/analytics';
import { useDemoData } from '../context/DemoDataContext';

type DemoEvent =
  | 'demo_started'
  | 'demo_action_attendance'
  | 'demo_action_homework'
  | 'demo_action_observation'
  | 'demo_cta_signup_clicked'
  | 'demo_reset';

export function useDemoAnalytics() {
  const { isAnalyticsEmitted, markAnalyticsEmitted } = useDemoData();

  const trackOnce = useCallback(
    (event: DemoEvent) => {
      if (isAnalyticsEmitted(event)) return;
      markAnalyticsEmitted(event);
      try {
        track(event);
      } catch {
        // analytics unavailable — silent fail
      }
    },
    [isAnalyticsEmitted, markAnalyticsEmitted]
  );

  return { trackOnce };
}
